import React from 'react';
import { cn } from './cn';

/**
 * DurationCell — render a length in seconds as MM:SS (or H:MM:SS), monospace.
 * Used in Sessions, Quick Taps, Audiobooks, Background Music, Captions queue.
 *
 *   <DurationCell seconds={572} />     →  "09:32"
 *   <DurationCell seconds={3972} />    →  "1:06:12"
 *   <DurationCell value="09:32" />     →  passthrough
 */
function formatSeconds(s) {
  if (!Number.isFinite(s) || s < 0) return '—';
  const total = Math.round(s);
  const h = Math.floor(total / 3600);
  const m = Math.floor((total % 3600) / 60);
  const sec = total % 60;
  const mm = h > 0 ? String(m).padStart(2, '0') : String(m).padStart(2, '0');
  const ss = String(sec).padStart(2, '0');
  return h > 0 ? `${h}:${mm}:${ss}` : `${mm}:${ss}`;
}

export function DurationCell({ seconds, value, className }) {
  const display = value ?? formatSeconds(seconds);
  // `.duration` (prototype line 1244): JetBrains Mono 12.5px navy, 500.
  return (
    <span
      className={cn('font-mono text-navy', className)}
      style={{ fontSize: 12.5, fontWeight: 500 }}
    >
      {display}
    </span>
  );
}

export default DurationCell;
